import cloneDeep from 'lodash.clonedeep';
import { CollectionFunction } from 'data/collectionFunction/collectionFunction.types';
import {
  NetworkTopologyState,
  NetworkTopologyStateTypes,
  NetworkTopologyMapConfig,
  GET_NETWORK_TOPOLOGY,
  GET_NETWORK_TOPOLOGY_FULFILLED,
  GET_NETWORK_TOPOLOGY_PENDING,
  GET_NETWORK_TOPOLOGY_REJECTED,
  FILTER_NETWORK_TOPOLOGY,
  GET_NETWORK_TOPOLOGY_FILTERS,
  GET_NETWORK_TOPOLOGY_FILTERS_PENDING,
  GET_NETWORK_TOPOLOGY_FILTERS_FULFILLED,
  GET_NETWORK_TOPOLOGY_FILTERS_REJECTED,
  SET_NETWORK_TOPOLOGY_FILTER,
  GET_NETWORK_TOPOLOGY_CONFIG,
  GET_NETWORK_TOPOLOGY_CONFIG_FULFILLED,
  GET_NETWORK_TOPOLOGY_CONFIG_PENDING,
  GET_NETWORK_TOPOLOGY_CONFIG_REJECTED,
  newNetworkTopologyFilter,
  LOAD_MOCK_DATA_FILE,
  LOAD_MOCK_DATA_FILE_FULFILLED,
  NetworkTopologyElementsEnum
} from './network-topology.types';
import {
  adaptFromServerFormat2, filterNetworkTopologyData, getNetworkTopologyMapConfig, adaptCustomFilterServerResponse
} from './network-topology.adapter';

const initialState: NetworkTopologyState = {
  original: [],
  entities: [],
  networkTopologyMapConfg: getNetworkTopologyMapConfig(),
  ui: {
    isLoading: false,
    isNetworkTopologyLoaded: false,
  },
  customFilters: [],
  selectedCustomFilter: {
    ...newNetworkTopologyFilter
  },
  mapData: {
    accessFunctions: [], collectionFunctions: [], xcipioNodes: [], ccpags: [], mdf2s: [], mdf3s: [], admfs: []
  },
  originalMapData: {
    accessFunctions: [], collectionFunctions: [], xcipioNodes: [], ccpags: [], mdf2s: [], mdf3s: [], admfs: []
  },
  collectionFunctions: [],
  zoomInLocarion: undefined
};

export default function networkTopologyreducer(
  state = initialState,
  action: NetworkTopologyStateTypes,
): NetworkTopologyState {
  switch (action.type) {
    case GET_NETWORK_TOPOLOGY:
      return { ...state };
    case GET_NETWORK_TOPOLOGY_PENDING:
      return {
        ...state,
        ui: {
          ...state.ui,
          isLoading: true,
          isNetworkTopologyLoaded: false,
        }
      };
    case GET_NETWORK_TOPOLOGY_FULFILLED:
      const mapData = adaptFromServerFormat2(action.payload, state.networkTopologyMapConfg);
      return {
        ...state,
        mapData,
        originalMapData: mapData,
        collectionFunctions: cloneDeep(action.payload.find((item) => item.element === 'cf')?.data as CollectionFunction[]) || [],
        ui: {
          ...state.ui,
          isLoading: false,
          isNetworkTopologyLoaded: true,
        }
      };
    case GET_NETWORK_TOPOLOGY_REJECTED:
      return {
        ...state,
        ui: {
          ...state.ui,
          isLoading: false,
          isNetworkTopologyLoaded: true,
        }
      };
    case LOAD_MOCK_DATA_FILE_FULFILLED:
      const mockData = action.payload.data as {element: NetworkTopologyElementsEnum; data: unknown[]; }[];
      const mapData2 = adaptFromServerFormat2(mockData, state.networkTopologyMapConfg);

      return {
        ...state,
        mapData: mapData2,
        originalMapData: mapData2,
        collectionFunctions: cloneDeep(mockData.find((item) => item.element === 'cf')?.data as CollectionFunction[]) || [],
        ui: {
          ...state.ui,
          isLoading: false,
          isNetworkTopologyLoaded: true,
        }
      };
    case FILTER_NETWORK_TOPOLOGY:
      const { filteredMapData, filterLocation } = filterNetworkTopologyData(action.payload, state.originalMapData);
      return {
        ...state,
        mapData: cloneDeep(filteredMapData),
        zoomInLocarion: filterLocation,
      };
    case GET_NETWORK_TOPOLOGY_FILTERS:
      return { ...state };
    case GET_NETWORK_TOPOLOGY_FILTERS_PENDING:
      return {
        ...state,
        ui: {
          ...state.ui,
          isLoading: true,
        }
      };
    case GET_NETWORK_TOPOLOGY_FILTERS_FULFILLED:
      const filters = adaptCustomFilterServerResponse(action.payload.data.data || []);
      return {
        ...state,
        customFilters: filters,
        ui: {
          ...state.ui,
          isLoading: false,
        }
      };
    case GET_NETWORK_TOPOLOGY_FILTERS_REJECTED:
      return {
        ...state,
        ui: {
          ...state.ui,
          isLoading: false,
        }
      };

    case SET_NETWORK_TOPOLOGY_FILTER:
      return {
        ...state,
        selectedCustomFilter: { ...action.payload }
      };

    case GET_NETWORK_TOPOLOGY_CONFIG:
      return { ...state };
    case GET_NETWORK_TOPOLOGY_CONFIG_PENDING:
      return {
        ...state,
        ui: {
          ...state.ui,
          isLoading: true
        }
      };
    case GET_NETWORK_TOPOLOGY_CONFIG_FULFILLED:
      const mapConfig: NetworkTopologyMapConfig = action.payload.data;
      return {
        ...state,
        networkTopologyMapConfg: mapConfig,
        ui: {
          ...state.ui,
          isLoading: false,
        }
      };
    case GET_NETWORK_TOPOLOGY_CONFIG_REJECTED:
      return {
        ...state,
        ui: {
          ...state.ui,
          isLoading: false,
        }
      };

    default:
      return state;
  }
}
